import { AssignmentHelper } from '@shared/helpers/assignment.helper';

/**
 * Represents a row in the planning board.
 * Abstract : Both GroupRow and AssignmentRow extend this class.
 */
export abstract class PlanningRow {
  public rowId: string;

  public abstract height: number;
  public abstract isRowDroppable: boolean;
  public abstract styleClasses?: string[];

  public constructor(
    public projectId?: string,
    public departmentId?: string,
    public classId?: string,
    public resourceId?: string,
    ignoreResource = false
  ) {
    this.rowId = AssignmentHelper.getRowId({ projectId, departmentId, classId, resourceId }, ignoreResource);
  }

  public abstract getValueOrDefault(_periodId: number): unknown;
  public abstract setValue(value: unknown): void;
}
